// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1YcW2","rootCenter":"LoadMoreObserver_rootCenter__2Fate","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__L3lXr"};